import { render } from "./TheScrollTop.pug?vue&type=template&id=e1f2d680&lang=pug"
import script from "./TheScrollTop.js?vue&type=script&lang=js"
export * from "./TheScrollTop.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__